import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformService } from 'src/app/services/platform.service';

// Keep this URL in sync with the preload in src/index.html.
const PAYMENT_SCRIPT_URL =
  'https://teuteuf-web-components.pages.dev/teuteuf-payment-return.js';

@Component({
  selector: 'app-payment-return',
  templateUrl: './payment-return.component.html',
  styleUrls: ['./payment-return.component.scss'],
})
export class PaymentReturnComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('paymentHost') paymentHost?: ElementRef<HTMLDivElement>;

  status: string | null = null;

  private boundHandlePassportLink = this.handlePassportLink.bind(this);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private platform: PlatformService,
  ) {}

  ngOnInit(): void {
    if (!this.platform.isInBrowser()) return;
    this.status = this.getPaymentStatus();
  }

  ngAfterViewInit(): void {
    if (!this.platform.isInBrowser() || !this.status) return;
    this.loadScript();
    this.renderPaymentStatus();
    document.addEventListener('click', this.boundHandlePassportLink);
  }

  ngOnDestroy(): void {
    if (!this.platform.isInBrowser()) return;
    document.removeEventListener('click', this.boundHandlePassportLink);
  }

  private getPaymentStatus(): string | null {
    const params = this.route.snapshot.queryParamMap;
    return params.get('status');
  }

  private loadScript(): void {
    if (document.querySelector('script[data-teuteuf-payment-return]')) return;

    const script = document.createElement('script');
    script.src = PAYMENT_SCRIPT_URL;
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-teuteuf-payment-return', '');
    script.async = true;
    document.body.appendChild(script);
  }

  private renderPaymentStatus(): void {
    if (!this.status || !this.paymentHost) return;
    const locale = (navigator.language || 'en').split('-')[0];
    const theme = document.documentElement.classList.contains('dark')
      ? 'dark'
      : 'light';

    this.paymentHost.nativeElement.innerHTML =
      `<teuteuf-payment-return status="${this.status}" lang="${locale}" gameName="WhereTaken" ` +
      `tryAgainHref="/passport" theme="${theme}"></teuteuf-payment-return>`;
  }

  private handlePassportLink(event: MouseEvent): void {
    const path = (event.composedPath && event.composedPath()) || [];
    const anchor = path.find(
      (element): element is HTMLAnchorElement =>
        element instanceof HTMLAnchorElement &&
        element.getAttribute('href') === '/passport',
    );
    if (!anchor) return;

    event.preventDefault();
    this.router.navigate(['/passport']).catch(() => {});
  }
}
